import EditIcon from 'assets/ver2/icons/edit-document-upload-icon.svg';
import styled from 'styled-components';

const FormInputUploadDocumentsFileSelectedMask = ({ name, imgSrc }) => {
  return (
    <FormInputUploadDocumentsFileSelectedMaskStyled>
      <UploadedImage name={name} src={imgSrc} />
      <ActionImage src={EditIcon} />
    </FormInputUploadDocumentsFileSelectedMaskStyled>
  );
};

const FormInputUploadDocumentsFileSelectedMaskStyled = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const UploadedImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  position: absolute;
`;

const ActionImage = styled.img`
  width: 30px;
  height: 30px;
  position: absolute;
  top: 10px;
  right: 10px;
`;

export default FormInputUploadDocumentsFileSelectedMask;
